document.addEventListener('DOMContentLoaded', ()=>{

    if(document.querySelector('.jsGenerator')){
        const generator = document.querySelector('.jsGenerator');
        let items = generator.querySelectorAll('[data-generator]');
        let tabs = generator.querySelectorAll('.jsGeneratorTab');
        let previews = generator.querySelectorAll('.jsGeneratorPreview');
    
        init()
    
        for (let index = 0; index < tabs.length; index++) {
            const item = tabs[index];

            item.addEventListener('change', ()=>{
                changeTab(index)
            })
        }
    
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            let props = item.getAttribute('data-generator');
            let prop = JSON.parse(props)[0]
            let value = JSON.parse(props)[1]
    
            item.addEventListener('change', ()=>{
                change(prop, value)
            })
        }
    
        function init(){
            let items = generator.querySelectorAll('[data-generator]:checked')
    
            for (let index = 0; index < items.length; index++) {
                const item = items[index];
                let props = item.getAttribute('data-generator');
                let prop = JSON.parse(props)[0]
                let value = JSON.parse(props)[1]
                change(prop, value)
            }

            for (let index = 0; index < tabs.length; index++) {
                const item = tabs[index];

                if(item.checked){
                    changeTab(index)
                }
            }
        }

        function changeTab(index){
            for (let i = 0; i < previews.length; i++) {
                previews[i].classList.remove('is-active')
            }

            previews[index].classList.add('is-active')
        }

        function change(prop, value){
            for (let index = 0; index < previews.length; index++) {
                const item = previews[index];
                let style = item.querySelectorAll('svg defs style')
    
                switch(prop) {
                    case 'fill':
                        if (value.length > 1){
                            style[0].innerHTML = `.cls-1{fill:` +value[0] + `;} .cls-bg{fill:` + value[1] + `;}`;
                        } else{
                            style[0].innerHTML = `.cls-1{fill:` + value[0] + `;}`;
                        }
                        break;
    
                    case 'bg':
                        style[1].innerHTML = `.cls-2{fill:` + value + `;}`;
                        break;
                    
                    default:
                        break;
                }
            }
        }
    }
})